import { addItems, get } from '../objects/cart/ajax_cart';

// how long the "Added to Cart" confirmation label stays on the button before
// it reverts back to "Add to Cart" — kept shorter than the 5s the
// cart-notification-popup card stays up, so it reads as part of that confirmation
const ADDED_STATE_DURATION_MS = 3000;
// how long a failed-add message stays under the button
const ERROR_DURATION_MS = 5000;

// COB2B-811: re-render the cart drawer and cart bubble after an add, separately
// from the add itself — the same sections /cart/add.js used to return, fetched
// through the Section Rendering API and handed to renderContents in the shape it
// already expects. If it fails the cart is still right; only the drawer is stale
// until the next render.
const refreshCartSections = (cartB, sections) => {
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}?sections=${sections}`)
    .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
    .then((data) => {
      if (cartB.classList.contains('is-empty'))
        cartB.classList.remove('is-empty');
      cartB.renderContents({ sections: data });
    })
    .catch(() => {});
};

const getCardTotalQuantity = ($card) => {
  let total = 0;
  $card.find('.quantity__input').each(function () {
    total += parseInt($(this).val(), 10) || 0;
  });
  return total;
};

// COB2B-783: multi-variant cards default every row to 0 quantity (COB2B-771),
// which used to leave the button clickable but silently doing nothing. Keep
// it disabled until the customer has picked a quantity instead.
const syncAddToCartButtonState = ($card) => {
  const $button = $card.find('.button__submit');
  if ($button.hasClass('loading')) return; // don't fight the in-flight request
  $button.prop('disabled', getCardTotalQuantity($card) === 0);
};

const cardAddtoCart = () => {
  const cartB =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');

  $('body').on(
    'click',
    '.card__information--cart form .button__submit',
    function (e) {
      e.preventDefault();
      const $this = $(this);
      const $card = $this.parents('.card__information--cart');

      const $quantityInputs = $card.find('.quantity__input');
      const products = [];

      $quantityInputs.each(function () {
        const quantity = parseInt($(this).val(), 10);
        const productId = $(this).data('variant-id');

        if (quantity > 0 && productId) {
          products.push({ id: productId, quantity });
        }
      });

      // Defensive: syncAddToCartButtonState keeps the button disabled while
      // every row is 0, so this shouldn't fire — matches the guard already
      // used for volume-variant add-to-cart (volume_variants.js).
      if (!products.length) return;

      const sections = cartB
        ? cartB
            .getSectionsToRender()
            .map((section) => section.id)
            .toString()
        : '';
      const notification = document.querySelector('cart-notification-popup');

      const $text = $this.find('.button__submit-text');
      const showDefault = () => {
        clearTimeout($this.data('added-timeout'));
        $this.removeClass('added');
        $text.text($this.data('default-text'));
      };

      // COB2B-783: confirm the add with a label change instead of just
      // silently swapping the spinner back out for "Add to Cart".
      // COB2B-811: shown the moment the button is clicked rather than after
      // /cart/add.js answers — that request alone takes ~1s for a B2B cart on
      // UAT, which no theme change can shorten — and only momentarily (while
      // the confirmation card is up) before reverting to "Add to Cart". A
      // failed add takes it back straight away (below).
      clearTimeout($this.data('added-timeout'));
      $card.find('.card__atc-error').remove();
      $text.text($this.data('added-text'));
      $this.addClass('added');
      $this.data(
        'added-timeout',
        setTimeout(showDefault, ADDED_STATE_DURATION_MS),
      );

      // COB2B-811: the add no longer asks for `sections` either; the drawer and
      // cart bubble refresh in the background once it has succeeded.
      addItems(products, undefined, (response) => {
        let cartResponse = null;
        try {
          cartResponse = JSON.parse(response);
        } catch (error) {
          // malformed response — treated as a failed add below
        }

        // /cart/add.js answers a failed add (e.g. more than is in stock) with
        // {status, description} instead of {items} — undo the confirmation.
        if (!cartResponse || !Array.isArray(cartResponse.items)) {
          showDefault();
          const message =
            cartResponse?.description ||
            cartResponse?.message ||
            'Sorry, this could not be added to your cart.';
          const $error = $('<p class="card__atc-error" role="alert"></p>').text(
            message,
          );
          $this.after($error);
          setTimeout(() => $error.remove(), ERROR_DURATION_MS);
          // A 422 can still be a partial add ("Only 111 items were added…"),
          // so the drawer and bubble are refreshed either way.
          if (cartB && sections) refreshCartSections(cartB, sections);
          return;
        }

        // COB2B-811: the card is re-enabled for product cards and the PDP (see
        // snippets/cart-notification-popup.liquid).
        try {
          notification?.addMessage(cartResponse);
        } catch (error) {
          // the confirmation above already shows; the card is extra
        }

        if (cartB && sections) refreshCartSections(cartB, sections);
      });
    },
  );

  // enable/disable the Add to Cart button as the customer edits quantities
  $('body').on(
    'change input',
    '.card__information--cart .quantity__input',
    function () {
      syncAddToCartButtonState($(this).parents('.card__information--cart'));
    },
  );

  if (window.location.pathname.includes('swym-wishlist')) {
    function swymCallbackFn(swat) {
      swat.evtLayer.addEventListener('sw:addedtocart', async function (e) {
        if (cartB && cartB.classList.contains('is-empty'))
          cartB.classList.remove('is-empty');
        const cartResponse = await fetch('?sections=cart-drawer');
        const data = await cartResponse.json();
        cartB.renderContents({ sections: data });
      });
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }
};

export default cardAddtoCart;
